const faqs = [
  {
    question: "Is it free?",
    answer:
      "Yes. BeautifyIN runs without an account and the manual editor is fully available.",
  },
  {
    question: "Do I need a LinkedIn URL?",
    answer:
      "No. A URL can be entered, but the app works completely with manually pasted post text.",
  },
  {
    question: "Can I download the image?",
    answer:
      "Yes. The Download Image button exports only the designed post canvas as a PNG or JPG.",
  },
  {
    question: "What format do I get?",
    answer:
      "You can choose PNG or JPG. JPG exports include a quality control for smaller files.",
  },
  {
    question: "Why didn't URL import work?",
    answer:
      "LinkedIn can block automated fetching, and private or restricted posts are not imported. Paste the text manually when that happens.",
  },
  {
    question: "Can I use this for other people's posts?",
    answer:
      "Use it only when you have permission and keep attribution clear. The tool is meant for public content or text you provide.",
  },
];

export function FAQSection() {
  return (
    <section
      id="faq"
      className="border-t border-slate-200/70 bg-white/70 py-14"
      aria-labelledby="faq-heading"
    >
      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
        <div className="mb-8">
          <p className="text-sm font-semibold uppercase tracking-[0.18em] text-ocean">
            FAQ
          </p>
          <h2 id="faq-heading" className="mt-2 text-3xl font-bold text-ink">
            Common questions
          </h2>
        </div>
        <div className="divide-y divide-slate-200 rounded-lg border border-slate-200 bg-white shadow-sm">
          {faqs.map((faq) => (
            <details key={faq.question} className="group p-5">
              <summary className="cursor-pointer list-none text-base font-semibold text-ink marker:hidden">
                <span className="flex items-center justify-between gap-4">
                  {faq.question}
                  <span className="grid h-7 w-7 shrink-0 place-items-center rounded-full bg-slate-100 text-lg leading-none text-ocean group-open:hidden">
                    +
                  </span>
                  <span className="hidden h-7 w-7 shrink-0 place-items-center rounded-full bg-slate-100 text-lg leading-none text-ocean group-open:grid">
                    -
                  </span>
                </span>
              </summary>
              <p className="mt-3 leading-7 text-slate-600">{faq.answer}</p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}
